import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import Handlebars from "handlebars";
import CommentsArranger from './comments-arranger';

Snappy.Component.Comments = class Comments extends Snappy.BaseComponent {
    static get tagName() {
        return 'comments';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();
        this.init();
    }

    setVars() {
        this.$document = $(document);
        this.endpoints = {
            getAll: this.$element.data('getComments'),
            add: this.$element.data('addComment'),
            update: this.$element.data('updateComment'),
            abuseReport: this.$element.data('abuseReport'),
            remove: this.$element.data('removeComment'),
            like: this.$element.data('likeComment'),
            unlike: this.$element.data('unlikeComment'),
            getLikes: this.$element.data('likesList')
        };
        this.postId = this.$element.data('postId');
        this.userId = this.$element.data('uid');
        this.pageSize = this.$element.data('pageSize');
        this.initials = this.$element.data('initials');
        this.commentTemplateFunc = null;
        this.$activeReplyWrapper = null;
        this.ajaxFailMessage = 'Something went wrong. Please try again later.';

        this.$container = this.$element.find('.js-comments-list');
        this.$postForm = this.$element.find('.js-comments-post-form');
        this.$postBtn = this.$element.find('.js-comments-post-btn');
        this.$postText = this.$element.find('.js-comments-post-text');
        this.listTemplateSource = $('#comment-list-template').html();
        this.commentTemplateSource = $('#comment-template').html();

        this.reportedText = 'This comment has been reported and is awaiting moderation';
        this.actions = ['Like', 'Reply', 'ReplyPost', 'ReplyCancel', 'Report', 'Edit', 'Remove', 'EditSave', 'EditCancel'];
    }

    setEventListeners() {
        this.$container.on('click', this.generalClick.bind(this));
        this.$container.on('click', '.js-comments-more', this.moreClickHandler.bind(this));
        this.$postForm.on('submit', this.addComment.bind(this));
    }

    init() {
        if (typeof window.IntersectionObserver === 'function') {
            this.observer = new IntersectionObserver(this.observerCallback.bind(this), {
                threshold: 0
            });
            this.observer.observe(this.$container[0]);
        }
        else {
            setTimeout(()=>{
                this.initialShowComments();
            }, 500);
        }
    }

    postRequest(url, responseHandler, $container) {
        $.post( url, ( data ) => {
            if (data.success) {
                this.hideError($container);
                responseHandler(data);
            } else {
                this.showError($container, data.message);
            }

        }).fail((response) => {
            this.showError($container, this.ajaxFailMessage);
        })
    }

    addComment(e) {
        e.preventDefault();
        const text = this.$postText.val().replace(/\n/g, '<br />');
        if (!text.length) {
            return;
        }
        this.$postBtn.attr('disabled');

        const url = `${this.endpoints.add}?postId=${this.postId}&body=${text}&uid=${this.userId}`;
        this.postRequest(url, this.addCommentResultHandler.bind(this), this.$postForm);
    }

    addCommentResultHandler(data) {
        this.$postBtn.removeAttr('disabled');
        this.$postText.val('');

        const result = data.result;
        result.authenticated = true;
        const htmlString = this.commentTemplateFunc(result);
        this.$container.prepend(htmlString);
        this.incrementCount();
    }

    generalClick(e) {
        const $interactiveEl = $(e.target).closest('button');
        if (!$interactiveEl.length) {
            return;
        }
        const $currentComment = $interactiveEl.closest('.js-comments-item');

        const action = $interactiveEl.data('action');
        if (this.actions.indexOf(action) > -1) {
            this[`onClick${action}`]($currentComment, $interactiveEl);
        }
    }

    onClickLike($currentComment, $interactiveEl) {
        const id = $currentComment.data('id');
        $interactiveEl.attr('disabled');
        const responseHandler = this.likeResultHandler.bind(this, $currentComment, $interactiveEl);
        if ($currentComment.hasClass('is-liked')) {
            const url = `${this.endpoints.unlike}?commentId=${id}&uid=${this.userId}`;
            this.postRequest(url, responseHandler, $currentComment);

        } else {
            const url = `${this.endpoints.like}?commentId=${id}&uid=${this.userId}`;
            this.postRequest(url, responseHandler, $currentComment);
        }
    }

    likeResultHandler($currentComment, $interactiveEl, data) {
        const $likeCount = $interactiveEl.find('.js-comments-like-count');
        const $likeText = $interactiveEl.find('.js-comments-like-text');
        const result = data.result;

        if (result.isLiked) {
            $currentComment.addClass('is-liked');
            $likeText.text('Liked');
        } else {
            $currentComment.removeClass('is-liked');
            $likeText.text('Like');
        }

        if (result.count > 0) {
            $currentComment.addClass('is-likes');
        } else {
            $currentComment.removeClass('is-likes');
        }
        $likeCount.text(result.count);
        $interactiveEl.removeAttr('disabled');
    }

    onClickReply($currentComment, $interactiveEl) {

        if (this.$activeReplyWrapper) {
            this.$activeReplyWrapper.remove();
            this.$activeReplyWrapper = null;
        }
        const id = $currentComment.data('id');
        const parentDepth = parseInt($currentComment.data('depth'));
        //const isMaxDepth = (parentDepth >= 2);
        const isMaxDepth = false;
        const $childsContainer = $currentComment.siblings('.js-comments-list');
        const object = {
            isReplying: true,
            depth: isMaxDepth ? 2 : parentDepth + 1,
            isOwnComment: true,
            renderCommentDetails: true,
            parentCommentId: id,
            author: {
                initials: this.initials
            }
        };
        const htmlString = this.commentTemplateFunc(object);
        const $replyWrapper = $(htmlString);

        if (!isMaxDepth) {
            $childsContainer.prepend($replyWrapper);
        } else {
            $childsContainer.after($replyWrapper);
        }

        this.$activeReplyWrapper = $replyWrapper;

        const $replyComment = $replyWrapper.find('.js-comments-item');
        const $textArea = $replyWrapper.find('.js-comments-text');
        $textArea.focus();
    }

    onClickReplyPost($currentComment, $interactiveEl) {

        const $textArea = $currentComment.find('.js-comments-text');
        const text = $textArea.val().replace(/\n/g, '<br />');
        const parentId = $currentComment.data('parentId');
        if (!text.length) {
            return;
        }

        $interactiveEl.attr('disabled');
        const url = `${this.endpoints.add}?postId=${this.postId}&parentCommentId=${parentId}&body=${text}&uid=${this.userId}`;
        const responseHandler = this.replyResultHandler.bind(this, $currentComment, $interactiveEl);
        this.postRequest(url, responseHandler, $currentComment);

    }

    replyResultHandler($currentComment, $interactiveEl, data) {
        const result = data.result;
        result.authenticated = true;
        const depth = $currentComment.data('depth');
        result.depth = depth;
        const htmlString = this.commentTemplateFunc(result);
        $currentComment.parent().replaceWith(htmlString);
        this.$activeReplyWrapper = null;
        this.incrementCount(result.parentCommentId);
    }

    onClickReplyCancel() {
        if (this.$activeReplyWrapper) {
            this.$activeReplyWrapper.remove();
            this.$activeReplyWrapper = null;
        }
    }

    onClickEdit($currentComment, $interactiveEl) {
        $currentComment.addClass('is-editing');
        const $textArea = $currentComment.find('.js-comments-text');
        const $content = $currentComment.find('.js-comments-content');

        const content = $content.text().replace(/  +/g, ' ').replace(/^\s+|\s+$/g, '');
        $textArea.val(content);
        $textArea.focus();
    }

    onClickEditCancel($currentComment) {
        $currentComment.removeClass('is-editing');
    }

    onClickEditSave($currentComment, $interactiveEl) {
        $interactiveEl.attr('disabled');
        const id = $currentComment.data('id');
        const $textArea = $currentComment.find('.js-comments-text');
        const text = $textArea.val().replace(/\n/g, '<br />');

        const url = `${this.endpoints.update}?commentId=${id}&body=${text}`;
        const responseHandler = this.editSaveHandler.bind(this, $currentComment, $interactiveEl)
        this.postRequest(url, responseHandler, $currentComment);
    }

    editSaveHandler($currentComment, $interactiveEl, data) {
        $interactiveEl.removeAttr('disabled');
        $currentComment.removeClass('is-editing');
        const $content = $currentComment.find('.js-comments-content');
        $content.html(data.result.body);
    }

    onClickReport($currentComment, $interactiveEl) {
        const id = $currentComment.data('id');

        const url = `${this.endpoints.abuseReport}?commentId=${id}`;
        const responseHandler = this.reportResultHandler.bind(this, $currentComment, $interactiveEl);

        this.postRequest(url, responseHandler, $currentComment);
    }

    reportResultHandler($currentComment, $interactiveEl, data) {
        const $content = $currentComment.find('.js-comments-content');
        $content.text(this.reportedText);
        $currentComment.addClass('is-reported');
        this.removeReplyingChilds($currentComment);
    }

    showError($container, message){
        $container.addClass('is-error');
        const $error = $container.find('.js-comments-error');
        $error.text(message);
    }

    hideError($container) {
        $container.removeClass('is-error');
        const $error = $container.find('.js-comments-error');
        $error.empty();
    }

    onClickRemove($currentComment, $interactiveEl) {
        if (confirm('Are you sure you want to delete this comment?')) {
            const id = $currentComment.data('id');

            const url = `${this.endpoints.remove}?commentId=${id}`;
            const responseHandler = this.removeResultHandler.bind(this, $currentComment, $interactiveEl);
            this.postRequest(url, responseHandler, $currentComment);
        }
    }

    removeResultHandler($currentComment, $interactiveEl, data) {
        const $content = $currentComment.find('.js-comments-content');
        $content.text(data.message);
        $currentComment.addClass('is-deleted');
        this.removeReplyingChilds($currentComment);
    }

    observerCallback(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                this.observer.unobserve(this.$container[0]);
                this.initialShowComments();
            }
        });
    }

    initialShowComments() {
        this.listTemplateFunc = Handlebars.compile(this.listTemplateSource);
        Handlebars.registerPartial( "list", this.listTemplateSource );
        Handlebars.registerPartial( "comment", this.commentTemplateSource );
        this.commentTemplateFunc = Handlebars.compile(this.commentTemplateSource);
        this.fetchComments({depth: 0});

    }

    async fetchComments(params) {
        const { startId, depth } = params;
        const data = await this.getCommentPage(params);
        const result = data.result;
        this.latestReceivedCommentsCount = result.comments.length;
        let preparedData = CommentsArranger.prepareData(result);

        preparedData.items = CommentsArranger.setDepth(preparedData.items, depth);

        const idList = CommentsArranger.getIdList(data.result);
        const idListString = idList.map(item => `commentIds=${item}`).join('&');

        let likesData = null;
        let finalResults = null;

        if (idListString) {
            likesData = await this.getLikes(idListString);
        }

        if (likesData && likesData.success) {
            finalResults = CommentsArranger.setLikes(preparedData, likesData.result.likes);
        } else {
            finalResults = preparedData;
        }

        this.renderComments(finalResults, startId);
        this.updateMoreButtons();
    }

    getCommentPage(params) {
        const {startId, parentId, depth} = params;
        const queryArray = [
            this.endpoints.getAll,
            `uid=${this.userId}`,
            `depth=${depth}`
        ];
        if (startId) {
            queryArray.push(`startReplyId=${startId}`);
        }
        if (parentId) {
            queryArray.push(`parentId=${parentId}`);
        }
        const qs = queryArray.join('&');
        return $.get(qs);
    }

    getLikes(idListString) {
        const qs = `${this.endpoints.getLikes}?uid=${this.userId}&${idListString}`;
        return $.get(qs);
    }

    incrementCount(parentCommentId) {
        const $count = this.$element.find('.js-comments-count');
        if (!$count.length) {
            return;
        }
        const count = parseInt($count[0].innerText);
        $count.text(count + 1);

        //increment replies count if there is a parent comment
        if (parentCommentId) {
            const $comment = this.$container.find(`.js-comments-item[data-id="${parentCommentId}"]`);
            const $commentListItem = $comment.closest('.js-comments-list-item');
            const $replyCountContainer = $comment.find('.js-reply-count-container');
            const $replyCount = $replyCountContainer.find('.js-reply-count');
            const newReplyCount = parseInt($replyCount.text()) + 1;
            $replyCount.text(newReplyCount);
            $replyCountContainer.addClass('is-visible');
            const $list = $commentListItem.find('>.js-comments-list');
            $list.data('replyCount', newReplyCount);
        }
    }

    removeReplyingChilds($currentComment) {
        const $reply = $currentComment.parent().find('.js-comments-item.is-replying');
        $reply.parent().remove();
    }

    renderComments(data, startId) {
        const htmlString = this.listTemplateFunc(data);
        if (!startId) {
            this.$container.append(htmlString);
        } else {
            const $lastComment = this.$container.find(`.js-comments-item[data-id="${startId}"]`).eq(0);
            const $lastListItem = $lastComment.closest('.js-comments-list-item');
            $lastListItem.after(htmlString);
        }

        //$(window).trigger('content:updated');
    }

    moreClickHandler(e) {
        const $btn = $(e.target);
        const $list = $btn.closest('.js-comments-list');
        const $sameLevelItems = $list.find('>.js-comments-list-item');
        const $lastItem = $sameLevelItems.last();

        const $lastComment = $lastItem.find('>.js-comments-item');
        const depth = $lastComment.data('depth');
        const startId = $lastComment.data('id');
        const parentId = $lastComment.data('parentId');
        this.fetchComments({startId, parentId, depth});
        $btn.remove();
    }

    updateMoreButtons() {
        const $moreButtons = this.$container.find('.js-comments-more');
        $moreButtons.each((i, btn) => {
            const $moreBtn = $(btn);
            const $list = $moreBtn.closest('.js-comments-list');
            const replyCount = $list.data('replyCount');
            const listItemsCount = $list.find('>.js-comments-list-item').length;
            if (typeof replyCount === 'number' && listItemsCount >= replyCount) {
                $moreBtn.remove();
            }

            // first level reply button
            if ((typeof replyCount !== 'number') && ((listItemsCount % this.pageSize) || this.latestReceivedCommentsCount === 0)) {
                $moreBtn.remove();
            }

        })
    }
};



// WEBPACK FOOTER //
// ./components/comments/scripts/comments.js